import { forceReassignTasks } from '@dispatch/shared/services';
import { useMutate } from '../api/useMutate';

export const useForceReassign = (
  responseFn: (data: {
    success: boolean;
    message?: string;
  }) => void | Promise<unknown>
) => {
  return useMutate(
    ['reassign-tasks'],
    (data: { taskIds: string[]; resourceId: string; reasonCode?: string }) =>
      forceReassignTasks(data),
    responseFn as (data: unknown) => void | Promise<unknown>
  );
};
